export const safeStringify = (
  value: unknown,
  space?: number,
): string | undefined => {
  try {
    return value == null ? undefined : JSON.stringify(value, null, space)
  } catch {
    return '[unserializable]'
  }
}
